import { makeStyles } from '@mui/styles';

import { globalTheme as theme } from '@styles';

export type ColorOptions =
  | 'textPrimary'
  | 'textBlue'
  | 'textDark'
  | 'textSecondary'
  | 'textWhite'
  | 'textGrey'
  | 'textDarkGray'
  | 'textGreen'
  | 'textBlueDarker'
  | 'textBlack'
  | 'default';

interface Props {
  color: ColorOptions;
}

// Define the color mapping
const colorMap: Record<ColorOptions, string> = {
  textDark: theme.palette.brandDarkBlue.main,
  textPrimary: theme.palette.text.primary,
  textSecondary: theme.palette.text.secondary,
  textGrey: theme.palette.brandGray.main,
  textDarkGray: theme.palette.brandGray.darker!,
  textWhite: '#FFFFFF',
  textGreen: theme.palette.brandGreen.darker!,
  textBlueDarker: theme.palette.brandBlue.darker!,
  textBlack: '#000000',
  textBlue: theme.palette.brandBlue.main,
  default: theme.palette.text.primary,
};

export const useStyles = makeStyles(() => ({
  root: {
    color: (props: Props) => colorMap[props.color],
  },
}));
